import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'APM_SERIES',
    itemActionName: 'APM_SERIES_ITEM',
});
